export default {
  jwtToken: 'token',
};
